import { Address } from "@/services/backend/addresses/types/address";

export function AddressToLine({ address }: { address?: Address }) {
  if (!address) {
    return null;
  }

  return (
    <span>
      {address.street} {address.postalCode} {address.city}
    </span>
  );
}
